import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FieldWrap } from './index';
import { FormError } from '../../interfaces';

const useStyles = createUseStyles({
    radio: {
        marginRight: '.5rem',
        height: '1em'
    }
});

interface RadioGroupProps {
    name: string;
    error?: FormError;
    register: (options: object) => any;
    defaultOption?: string;
    options: { label: string; value: string }[];
    disabled?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
    name,
    error,
    register,
    defaultOption,
    options,
    disabled = false
}: RadioGroupProps) => {
    const classes = useStyles();

    return (
        <FieldWrap error={error}>
            {options.map(({ label, value }, i) => (
                <label key={i}>
                    <input
                        name={name}
                        className={classes.radio}
                        disabled={disabled}
                        type="radio"
                        defaultChecked={defaultOption === value}
                        value={value}
                        ref={register}
                    />
                    {label}
                </label>
            ))}
        </FieldWrap>
    );
};

export default React.memo(RadioGroup);
